import React from 'react'

const SvgStrikethrough = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.429 13H5c-.667.003-1-.33-1-1 0-.67.333-1.003 1-1h3.643a3.867 3.867 0 01-.247-.267c-.601-.713-.901-1.634-.901-2.762 0-1.214.443-2.179 1.33-2.896C9.713 4.358 10.881 4 12.331 4c1.512 0 2.903.291 4.174.873.434.265.583.645.445 1.139-.137.493-.483.674-1.036.543-1.298-.554-2.506-.83-3.624-.83-.898 0-1.6.198-2.108.596-.507.397-.761.954-.761 1.671 0 .511.098.935.295 1.272.197.337.514.644.953.921.383.242.957.514 1.723.815H19c.668-.003 1.001.33 1 1-.001.67-.334 1.003-1 1h-3.046c.211.236.385.488.52.756.262.522.393 1.145.393 1.869 0 1.355-.476 2.423-1.43 3.204-.952.78-2.278 1.171-3.976 1.171-1.598 0-2.873-.194-3.825-.582-.118-.048-.763-.458-.614-1.198.149-.74.752-.63 1.002-.542.436.153.896.28 1.381.385.763.163 1.476.244 2.139.244 1.132 0 1.985-.223 2.558-.67.573-.447.86-1.061.86-1.842 0-.518-.104-.944-.311-1.277-.207-.334-.554-.646-1.041-.937-.3-.179-.693-.373-1.181-.581z'
    />
  </svg>
)

export default SvgStrikethrough
